// extracted by mini-css-extract-plugin
export var formContainer = "_cf-0";
export var message = "_cf-1";